import CryptoJS from "crypto-js";

// =====================================================
// BASE64 URL
// =====================================================
export function base64UrlEncode(str: string): string {
    return str.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

export function base64UrlDecode(str: string): string {
    str = str.replace(/-/g, "+").replace(/_/g, "/");
    while (str.length % 4) str += "=";
    return str;
}

// =====================================================
// CRYPTO
// =====================================================
export function encrypt(data: any, secretKey: string): string {
    const text = typeof data === "string" ? data : JSON.stringify(data);
    const encrypted = CryptoJS.AES.encrypt(text, secretKey).toString();
    return base64UrlEncode(encrypted);
}

export function decrypt(encoded: string, secretKey: string): any {
    try {
        const b64 = base64UrlDecode(encoded);
        const bytes = CryptoJS.AES.decrypt(b64, secretKey);
        const dec = bytes.toString(CryptoJS.enc.Utf8);

        try {
            return JSON.parse(dec);
        } catch {
            return dec;
        }
    } catch {
        return "";
    }
}

export function generateKey(length = 12): string {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let out = "";

    for (let i = 0; i < length; i++) {
        out += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return out;
}